/**
 * Shared utility functions for assignee display styling
 * Used by both ClientRow and AssigneeFilterChips to ensure consistent colors
 */

// Generate consistent colors for avatars based on index
// Excludes red/alert colors to avoid alarming appearance
export const getAvatarColor = (index: number): string => {
  const colors = [
    "#0077CC", // blue
    "#2e7d32", // green
    "#c15800", // orange
    "#a78a2e", // yellow-gold
    "#383794", // purple
    "#1976d2", // light blue
    "#00477A", // dark blue
  ];
  return colors[index % colors.length];
};

// Get initials from name
export const getInitials = (firstName?: string, lastName?: string): string => {
  if (!firstName && !lastName) return "U";
  const firstInitial = firstName?.charAt(0).toUpperCase() || "";
  const lastInitial = lastName?.charAt(0).toUpperCase() || "";
  return `${firstInitial}${lastInitial}`;
};

// Get a consistent color for a user based on their userId
// This ensures the same user always gets the same color
export const getConsistentColorForUser = (userId?: string): string => {
  if (!userId) return "#6c757d"; // gray for unassigned

  // Simple hash function to convert userId to a consistent index
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash << 5) - hash + userId.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Use absolute value and modulo to get a consistent color index
  const colorIndex = Math.abs(hash) % 8;
  return getAvatarColor(colorIndex);
};
